<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="450">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input" @submit.prevent="submitForm">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4 v-if="record">Update "{{ record.name }}" Expense Type</h4>
                    <h4 v-else>New Vehicle Expense Type</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <company-select v-if="user.type === 'admin'"
                                      v-model="formData['company_id']"
                                      :items="companies"
                                      clearable
                                      density="compact" label="Company">
                            </company-select>

                            <v-text-field v-model="formData['name']"
                                          :rules="[vRules.required,vRules.maxLength(50)]"
                                          autofocus density="compact" label="Name"/>

                            <v-textarea v-model="formData['description']"
                                        density="compact" label="Description" maxlength="255"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {useAuthStore} from "@/stores/authStore";
import CompanySelect from "@/components/globals/company-select.vue";

const snackbar = useSnackbarStore();
const {user} = useAuthStore();
const props = defineProps({
    modelValue: Boolean,
    record: Object,
});
const formData = reactive({
    valid: false,
    name: props.record?.name ?? null,
    description: props.record?.description ?? null,
    company_id: props.record ? props.record?.company_id : ((user.type !== 'admin') ? user.company.id : null),
});
const emits = defineEmits(['update:modelValue', 'addRecord', 'updateRecord']);
const dialogSwitch = ref(props.modelValue);
const companies = ref([]);
const errors = ref([]);

onMounted(() => {
    if (user.type === 'admin') {
        fetchCompanies()
    }
})

const fetchCompanies = () => {
    send('get', `companies/list`)
        .then((response) => {
            companies.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            snackbar.showSnackbar('Companies could not be loaded', 'error')
        })
}
const submitForm = () => {
    errors.value = [];
    send(`${props.record ? 'put' : 'post'}`,
        `fleet/expense-types${props.record ? '/' + props.record.id : ''}`,
        formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits(props.record ? 'updateRecord' : 'addRecord', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response?.data?.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response?.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
